import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { suppressResizeObserverError } from "./utils/suppressResizeObserver";

// Supprimer l'erreur ResizeObserver en développement
if (process.env.NODE_ENV === "development") {
  suppressResizeObserverError();
}

// ✅ Ignore uniquement l'erreur ResizeObserver (bug Ant Design / Chrome)
const resizeObserverErr = (e) =>
  e.message === "ResizeObserver loop completed with undelivered notifications";

// ⚡ Écoute les erreurs globales et stoppe celles de ResizeObserver
window.addEventListener("error", (e) => {
  if (resizeObserverErr(e)) {
    e.stopImmediatePropagation();
  }
});

// ⚡ Facultatif : corrige aussi dans "unhandledrejection"
window.addEventListener("unhandledrejection", (e) => {
  if (resizeObserverErr(e.reason)) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
